import * as React from 'react';
import RCForm, { List, useForm, useWatch } from 'rc-field-form';
import styled from 'styled-components';
import { Form as TDForm } from 'tdesign-react';
import { useRef } from 'react';
import { isVoid } from '@/utils/common';
import FormItem from './FormItem';

/**
 * @typedef {import("./type").Props} Props
 */

/**
 * @param {Props} props
 * @returns
 */
function Form({
  layout,
  className,
  style,
  labelAlign,
  labelWidth,
  children,
  onFinishFailed,
  preserve,
  ...others
}) {
  const tdFormRef = useRef();

  function scrollToError() {
    const dom = tdFormRef.current.querySelector?.('.t-form--has-error');
    dom && dom.scrollIntoView({ behavior: 'smooth' });
  }

  const onFailed = (params) => {
    scrollToError();
    if (onFinishFailed) {
      onFinishFailed(params);
    }
  };

  return (
    <RCForm
      component='div'
      preserve={isVoid(preserve) ? false : preserve}
      onFinishFailed={onFailed}
      {...others}
    >
      <Root ref={tdFormRef}>
        <TDForm
          layout={layout}
          className={className}
          style={style}
          labelAlign={labelAlign}
          labelWidth={labelWidth}
          preventSubmitDefault={false}
        >
          {children}
        </TDForm>
      </Root>
    </RCForm>
  );
}

Form.FormItem = FormItem;
Form.List = List;
Form.useForm = useForm;
Form.useWatch = useWatch;

export default Form;

const Root = styled.div`
  .t-input__extra {
    background-color: white;
  }
`;
